<template>
    <el-tree :data="treeData" node-key="id" :default-expanded-keys="[1000, 1001,1002]"  :props="defaultProps"@node-click="handleNodeClick" class="el-tree" ></el-tree>
</template>

<script>
    //导入 HTTP请求方法
    import {getIndexNavTree} from '../api/api'

    //定义组件
    export default{
        data(){
            return {
                treeData:[],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
            }
        },
        //挂载时候执行
        mounted(){
            //左侧树
            getIndexNavTree({}).then((res) => {
                console.log(res);
                this.treeData = res.data.value;
            });
        },

        methods:{
            handleNodeClick(data) {
                var ids=data.id;

                this.$emit('nodeClick',ids);



            },
        }
    }

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .el-tree{
        display:inline-block;    width:200px;    height:700px;vertical-align:top;
    }
    .el-table{
        color: #222222;
    }
    .el-table th{
        background: #eef1f6;
        color: #222222;
    }
    .select-wrap{
        margin: 10px 20px;
    }
    .pagination-wrap{
        text-align: right;
        margin: 20px;
    }
    .select-wrap .el-form-item{
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/platformTree.vue